// {{{ Formats

function prepFormat(valPrep, fmt, postProc = v => v) {
	return v => {
		if (v != null) {
			v = valPrep(v);

			return postProc(fmt.format(v));
		}

		return '';
	};
}

Formats = ((lang) => ({
	date: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric' })),
	date_utc: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' })),
	datetime: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'})),
	time: prepFormat(v => new Date(v * 1000), new Intl.DateTimeFormat(lang, { hour: 'numeric', minute: 'numeric'})),

	// v is in seconds, output is in hours and minutes
	time_interval: v => {
		if (v == null || isNaN(Number(v))) {
			return '';
		}

		let parts = [];
		let mins = Math.floor(Number(v) / 60);
		let hours = Math.floor(mins / 60);
		let days = Math.floor(hours / 24);

		mins %= 60;
		hours %= 24;

		if (days) {
			parts.push(_n(days, '{n} dnů'));
		}

		if (hours) {
			parts.push(_n(hours, '{n} hodin'));
		}

		if (!hours || mins) {
			parts.push(_n(mins, '{n} minut'));
		}

		return parts.join(' ');
	},

	auto_rel_time: v => {
		if (v == null) {
			return '';
		}

		let today = Utils.formatDateIso(new Date);
		let v_day = Utils.formatDateIso(new Date(v * 1000));

		if (today == v_day) {
			return Formats.time(v);
		} else {
			return Formats.datetime(v);
		}
	},

	price: prepFormat(v => Number(v), new Intl.NumberFormat(lang, {
		style: 'currency',
		currency: 'CZK',
		maximumFractionDigits: 2,
		minimumFractionDigits: 0,
	})),

	amount: prepFormat(v => Number(v), new Intl.NumberFormat(lang, {
		maximumFractionDigits: 2,
		minimumFractionDigits: 0,
	})),

	distance: prepFormat(v => Number(v), new Intl.NumberFormat(lang, {
		maximumFractionDigits: 2,
		minimumFractionDigits: 0,
		useGrouping: false,

		//XXX: Safari holding the web back, again
		//unit: 'kilometer',
		//style: 'unit',
	}), v => v + ' km'),

	percent: prepFormat(v => Number(v), new Intl.NumberFormat(lang, { maximumFractionDigits: 3 }), v => v + ' %'),

	input_date: v => {
		let d = new Date(v * 1000);

		if (lang == 'cs-CZ') {
			return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();  
		} else {
			return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();  
		}
	},

	input_datetime: v => {
		let d = new Date(v * 1000);
		let has_time = (d.getHours() + d.getMinutes() + d.getSeconds() + d.getMilliseconds()) > 0;

		function p(number) {
			return number < 10 ? '0' + number : number;
		}

		return Formats.input_date(v) + (has_time ? ' ' + d.getHours() + ':' + p(d.getMinutes()) : '');
	},

	bool: v => {
		return v ? _('Ano') : _('Ne');
	},

	order_status: v => {
		return {
			'new': _('Nová'),
			'accepted': _('Přijatá'),
			'delivering': _('Doručovaná'),
			'cancelled': _('Zrušená zákazníkem'),
			'rejected': _('Odmítnutá skladem'),
			'delivered': _('Dodaná'),
		}[v] || v;
	},

	order_action: v => {
		return {
			'create': _('Zadána zákazníkem'),
			'accept': _('Přijatá'),
			'delivering': _('Doručovaná'),
			'cancel': _('Zrušená zákazníkem'),
			'rejected': _('Odmítnutá skladem'),
			'delivered': _('Dodaná'),
			'send-message': _('Zpráva zákazníkovi'),
			'eta-update': _('Změna času dodání'),

			'gopay-create-payment': _('Vytvořena platba v GoPay'),
			'gopay-paid': _('Zaplaceno v GoPay'),
			'gopay-refunded': _('Peníze vráceny v GoPay'),

			'create-payment': _('Vytvořena platba v platební bráně'),
			'paid': _('Zaplaceno'),
			'refunded': _('Peníze vráceny'),

			'rejected-for-nonpayment': _('Zrušena - nezaplacena včas'),
			'complaint-accepted': _('Reklamce přijata'),
			'payment-method-change': _('Změna způsobu platby'),
			'driver-change': _('Změna řidiče'),
		}[v] || v;
	},

	vat_category: v => {
		return VAT_CATEGORIES_MAP.get(v) || v;
	},

	non_delivery_reason: v => {
		return NON_DELIVERY_REASONS_MAP.get(v) || v;
	},

	address_parts(a) {
		if (!a) {
			return null;
		}

		let cislo = (a.typ_so == 'e' ? 'č. ev. ' : '') + a.cd;
		let co = a.co ? '' + a.co + (a.zco || '') : '';
		let street = a.ulice ? a.ulice + ' ' + cislo : a.cast_obce + ' ' + cislo;

		return {
			street: street + (co ? '/' + co : ''),
			city: a.momc || a.obec,
			post_code: a.psc,
			location: a.location,
			kod: a.adresa_kod,
		};
	},

	address(a) {
		return Formats.address_simple(Formats.address_parts(a));
	},

	address_simple(a) {
		if (!a) {
			return '';
		}

		return [a.street, a.post_code + ' ' + a.city].join(', ');
	},
}))({
	cs: 'cs-CZ',
	en: 'en-US',
}[i18n.lang]);

// }}}

let VAT_CATEGORIES = [{
	text: 'Základní',
	id: 'base',
	value: 21,
}, {
	text: 'První snížená',
	id: 'low1',
	value: 15,
}, {
	text: 'Druhá snížená',
	id: 'low2',
	value: 10,
}];

let VAT_CATEGORIES_MAP = new Map(VAT_CATEGORIES.map(c => [c.id, c.value + ' %']));

let NON_DELIVERY_REASONS = [{
	value: 'unreachable_customer_phone',
	text: _('Nedovolal jsem se zákazníkovi'),
}, {
	value: 'customer_rejected_payment',
	text: _('Zákazník odmítl zaplatit'),
}, {
	value: 'invalid_details',
	text: _('Zákazník o objednávce nic neví'),
}, {
	value: 'car_issues',
	text: _('Porucha auta'),
}, {
	value: 'other',
	text: _('Jiný důvod'),
}];

let NON_DELIVERY_REASONS_MAP = new Map(NON_DELIVERY_REASONS.map(r => [r.value, r.text]));

NON_DELIVERY_REASONS_MAP.set('payment-timeout', _('Zákazník nedokončil platbu'));

let PAYMENT_METHODS = [{
	text: 'Hotově',
	value: 'cash',
}, {
	text: 'Kartou online',
	value: 'card',
}];

let PAYMENT_METHODS_MAP = new Map(PAYMENT_METHODS.map(c => [c.value, c.text]));

let ESHOP_DOCUMENTS = [{
	title: _('Obchodní podmínky'),
	url: '/docs/Obchodní podmínky pro nákup na alkoholtaxi.cz.pdf',
}, {
	title: _('Reklamační řád'),
	url: '/docs/REKLAMAČNÍ ŘÁD - pro prodej zboží v e-shopu alkoholtaxi.cz - Příloha č. 2 k OP.pdf',
}, {
	title: _('Reklamační protokol'),
	url: '/docs/Reklamační protokol - e-shop alkoholtaxi.cz.pdf',
}, {
	title: _('Oznámení o odstoupení od kupní smlouvy - VZOR'),
	url: '/docs/Vzorový formulář - Oznámení o odstoupení od kupní smlouvy - Příloha č. 1 k OP.pdf',
}, {
	title: _('Zpracování osobních údajů'),
	url: '/docs/Ochrana osobních údajů e-shopu alkoholtaxi.cz - Příloha č. 3 k OP.pdf',
}];

let ABOUT_US_TEXT = _('Dovezeme Vám alko i nealko nápoje až k Vám domů, po celé České republice a v nejkratším možném čase pomocí sítě lokálních skladů a řidičů taxi. Objednejte si svůj oblíbený nápoj domů nebo na párty právě teď. Těšíme se na Vaši objednávku :-)');
